import React from 'react';
import ScanPrintContent from '../shared/ScanPrintContent';

const StaffScanPrint = () => {
  return <ScanPrintContent />;
};

export default StaffScanPrint;
